import { HelpCenterHome } from '@/modules/help-center/components/home';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(HelpCenterHome);

export const roles: string[] = [];
export const path = '/help';
export const element = <AnimatedPage />